<div class="terms-conditions-external-cont">
  <div class="termsConditions__header">
    <app-ds-typography
      [tag]="'h1'"
      [size]="fontSize.XS"
      [color]="fontColor.Primary"
      [fontFamily]="fontFamily.SemiBold"
      [text]="'BOOKING_MODULE.TERMS_CONDITIONS_TITLE' | transloco">
    </app-ds-typography>
    <div class="termsConditions__header-description">
      <app-ds-typography
        [tag]="'h3'"
        [size]="fontSize.XXS"
        [color]="fontColor.Secondary"
        [fontFamily]="fontFamily.Regular"
        [text]="'BOOKING_MODULE.TERMS_MANIFEST' | transloco">
      </app-ds-typography>
    </div>
  </div>
  <ng-container *ngIf="!!summaryTerms.INDIVIDUAL_TERMS; else compactTerms">
    <ng-container *ngTemplateOutlet="individualTerms"></ng-container>
  </ng-container>
  <ng-container *ngIf="hasErrorInTerms">
    <div class="terms-error">
      <span class="only-error">
        {{ 'BOOKING_MODULE.ERRORS.MANDATORY_TERMS_SECTION' | transloco }}
      </span>
    </div>
  </ng-container>
</div>

<ng-template #individualTerms>
  <ng-container [formGroup]="form">
    <app-ds-generic-card>
      <div class="terms-and-conditions-cont">
        <ng-container *ngIf="isActivities">
          <ng-container *ngTemplateOutlet="individualCivitatisConditions"></ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="individualTermsAndConditions"></ng-container>
        <ng-container *ngTemplateOutlet="individualExtraTermsAndPolicies"></ng-container>
      </div>
    </app-ds-generic-card>
  </ng-container>
</ng-template>

<ng-template #individualCivitatisConditions>
  <div class="termsConditions__terms" *ngIf="!civitatisPolicies.DISABLED">
    <div class="termsConditions__terms-checkbox">
      <app-ds-checkbox
        (checkboxOnChecked)="checkValue(civitatisTermsFormControlName, $event)">
      </app-ds-checkbox>
    </div>
    <div class="termsConditions__terms-text">
      {{summaryTerms.INITIAL_TEXT}}
      {{civitatisPolicies.INITIAL_TEXT}} 
      <a [routerLink]="civitatisPolicies.HREF.COMMANDS" [state]="civitatisPolicies.HREF.STATE" skipLocationChange>{{civitatisPolicies.HREF.TEXT}}</a>
      {{civitatisPolicies.ALTERNATIVE_TEXT}}
    </div>
  </div>
</ng-template>

<ng-template #individualTermsAndConditions>
  <div class="termsConditions__terms">
    <div class="termsConditions__terms-checkbox">
      <app-ds-checkbox
        (checkboxOnChecked)="checkValue(termsFormControlName, $event)">
      </app-ds-checkbox>
    </div>
    <div class="termsConditions__terms-text">
      {{summaryTerms.INITIAL_TEXT}}
      <ng-container *ngIf="hasCampaignsTerms">
        <ng-container *ngTemplateOutlet="campaignsTermsTemplate"></ng-container>
      </ng-container>
      {{hasCampaignsTerms ? termsAndConditions.ALTERNATIVE_TEXT : termsAndConditions.INITIAL_TEXT}} 
      <a [routerLink]="termsAndConditions.HREF.COMMANDS" skipLocationChange>{{termsAndConditions.HREF.TEXT}}</a>
      {{summaryTerms.FINAL_TEXT}}
    </div>
  </div>
</ng-template>

<ng-template #individualExtraTermsAndPolicies>
  <div class="termsConditions__terms termsConditions__terms--last">
    <div class="termsConditions__terms-checkbox">
      <app-ds-checkbox
        (checkboxOnChecked)="checkValue(extraTermsFormControlName, $event)">
      </app-ds-checkbox>
    </div>
    <div class="termsConditions__terms-text">
      {{summaryTerms.INITIAL_TEXT}}
      <ng-container *ngIf="!treatmentPersonalPolicies.DISABLED">
        {{treatmentPersonalPolicies.INITIAL_TEXT}}
        <a [routerLink]="treatmentPersonalPolicies.HREF.COMMANDS" skipLocationChange>{{treatmentPersonalPolicies.HREF.TEXT}}</a>,
      </ng-container>
      {{!treatmentPersonalPolicies.DISABLED ? privacyPolicies.INITIAL_TEXT : privacyPolicies.ALTERNATIVE_TEXT}}
      <a [routerLink]="privacyPolicies.HREF.COMMANDS" skipLocationChange>{{privacyPolicies.HREF.TEXT}}</a>
      {{summaryTerms.FINAL_TEXT}}
    </div>
  </div>
</ng-template>

<ng-template #compactTerms>
  <ng-container [formGroup]="form">
    <div class="terms-and-conditions-cont">
      <ng-container *ngTemplateOutlet="allTermsAndPolicies"></ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #allTermsAndPolicies>
  <div class="termsConditions__terms termsConditions__terms--last">
    <div class="termsConditions__terms-checkbox">
      <app-ds-checkbox
        (checkboxOnChecked)="checkValue(termsFormControlName, $event)">
      </app-ds-checkbox>
    </div>
    <div class="termsConditions__terms-text">
      {{summaryTerms.INITIAL_TEXT}}
      <ng-container *ngIf="hasCampaignsTerms">
        <ng-container *ngTemplateOutlet="campaignsTermsTemplate"></ng-container>
      </ng-container>
      <ng-container *ngIf="!civitatisPolicies.DISABLED">
        {{civitatisPolicies.INITIAL_TEXT}} 
        <a [routerLink]="civitatisPolicies.HREF.COMMANDS" [state]="civitatisPolicies.HREF.STATE" skipLocationChange>{{civitatisPolicies.HREF.TEXT}}</a>
        {{civitatisPolicies.ALTERNATIVE_TEXT}},
      </ng-container>
      {{termsAndConditions.INITIAL_TEXT}} 
      <a [routerLink]="termsAndConditions.HREF.COMMANDS" skipLocationChange>{{termsAndConditions.HREF.TEXT}}</a>,
      <ng-container *ngIf="!treatmentPersonalPolicies.DISABLED">
        {{treatmentPersonalPolicies.INITIAL_TEXT}}
        <a [routerLink]="treatmentPersonalPolicies.HREF.COMMANDS" skipLocationChange>{{treatmentPersonalPolicies.HREF.TEXT}}</a>,
      </ng-container>
      {{privacyPolicies.INITIAL_TEXT}}
      <a [routerLink]="privacyPolicies.HREF.COMMANDS" skipLocationChange>{{privacyPolicies.HREF.TEXT}}</a>
      {{summaryTerms.FINAL_TEXT}}
    </div>
  </div>
</ng-template>

<ng-template #campaignsTermsTemplate>
  <ng-container *ngFor="let campaign of campaignsTerms; last as isLast; trackBy: trackById">
    <ng-container *ngIf="!campaign.DISABLED">
      {{campaign.INITIAL_TEXT}}
      <a [routerLink]="campaign.HREF.COMMANDS" [state]="campaign.HREF.STATE" skipLocationChange>{{campaign.HREF.TEXT}}</a>,
    </ng-container>
  </ng-container>
</ng-template>
